// src/contexts/projects/useProjects.ts
import { useContext } from 'react';
import { ProjectContext } from './ProjectContext';

export function useProjects() {
  const ctx = useContext(ProjectContext);
  if (!ctx) {
    throw new Error('useProjects must be used within ProjectProvider');
  }
  return ctx;
}